module.exports = __webpack_public_path__ + "static/media/10x10no2.d1149797.jpg";